import { render, staticRenderFns } from "./catalog-item.vue?vue&type=template&id=53ade7f8"
import script from "./catalog-item.vue?vue&type=script&lang=js"
export * from "./catalog-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports